// import waypoints from node_modules
import 'waypoints/lib/jquery.waypoints';
import 'waypoints/lib/shortcuts/sticky';

jQuery(function($) {

    if( $( '[data-wp-sticky]' ).length && $(window).width() > 992) {
        var sticky = new Waypoint.Sticky({
            element: $( '[data-wp-sticky]' ),
            handler: function(direction) {
                this.element.width( this.element.parent().width() );
            },
        });
    }
});